if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();
        // Prevent multiple instances of the same product quick add modal
        if (document.querySelectorAll(`#${this.id}`).length > 1) {
          this.remove();
          return;
        }
      }

      show(opener) {
        super.show(opener);
      }

      hide(preventFocus = false) {
        setTimeout(() => {
          this.removeAttribute('data-next-modal');
        }, 200);

        const cartNotification = document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        if (preventFocus) this.openedBy = null;
        super.hide();
      }
    }
  );
}
